export const sliderData = [
  {
    videoId: '89dfa35fdc8c6626d5753179',
    name: 'Bella Vasta',
    position: 'Founder of JUMP Consulting',
    icons: [
      { name: 'facebook', href: 'https://www.facebook.com/bellavasta1' },
      { name: 'website', href: 'https://jumpconsulting.net' }
    ]
  },
  {
    videoId: '4fdfa35fb08e0b93303f712e',
    name: 'Precy Tripoli',
    position: 'Social Media Marketing Coach',
    icons: [
      { name: 'instagram', href: 'https://www.instagram.com/precytripoli' }
    ]
  },
  {
    videoId: '7ddfa35fe22f8defa94f4681',
    name: 'Ian Anderson Grey',
    position: 'Confident Live Marketing Coach and Founder of Seriously Social ',
    icons: [
      {
        name: 'linkedin',
        href: 'https://www.linkedin.com/in/ianandersongray'
      },
      { name: 'website', href: 'https://iag.me' }
    ]
  },
  {
    videoId: '96dfa35f43a345c5afde21a4',
    name: 'Donna Moritz',
    position: 'Digital Content Strategist, Founder of Socially Sorted',
    icons: [
      { name: 'twitter', href: 'https://twitter.com/SociallySorted' },
      { name: 'website', href: 'https://sociallysorted.com.au/' }
    ]
  },
  {
    videoId: '83dea35f93cf839364c50b85',
    name: 'Mary Barnett',
    position: 'Text Marketing Expert, Founder of Another Brilliant Idea, Inc.',
    icons: [
      {
        name: 'facebook',
        href: 'https://www.facebook.com/mary.barnett1/about'
      },
      { name: 'website', href: 'https://anotherbrilliantidea.com' }
    ]
  },
  {
    videoId: '22dfa35f0607203b47c1573c',
    name: 'Claudia Sheridan',
    position:
      "Digital Marketing Strategist, Chief Connector at One Amazing Women's Network",
    icons: [
      { name: 'facebook', href: 'https://www.facebook.com/claudiasheridan' },
      { name: 'website', href: 'https://oawn.com' }
    ]
  },
  {
    videoId: '01dfa35f47d38b8c00c1ef28',
    name: 'Veronica Jeans',
    position: 'Ecommerce Business Coach & Shopify Expert',
    icons: [
      {
        name: 'facebook',
        href: 'https://www.facebook.com/veronicajeansmentor'
      },
      {
        name: 'website',
        href: 'https://veronicajeans.com/'
      }
    ]
  }
];
